export default {
  me: state => state.seller
};